'use strict';

var Classnames = require('classnames');
var React = require('react');
var ReactRouter = require('react-router');
var Reflux = require('reflux');

var Link = ReactRouter.Link;

var Constants = require('../constants');
var Global = require('../global');

var ResponsiveMixin = Global.ResponsiveMixin;

var isNode = typeof document === 'undefined';
if (!isNode) {
    require('./button.scss');
}

const images = {}
for (const dir of ['left', 'right'])
    for (const col of [1,2,3,5])
        images[dir+col] = require('../../../server/public/static/images/global/type-arrows/'+dir+'-grey'+col+'.png')

var Button = React.createClass({
    mixins: [ ResponsiveMixin ],

    propTypes: {
        // Display label
        label:     React.PropTypes.string.isRequired,

        // If set, button will be greyed out and won't respond to clicks
        inactive:  React.PropTypes.bool,

        // Callback (not used if /inactive/ is set)
        onClick:   React.PropTypes.func,

        // Append additional classnames
        className: React.PropTypes.string,

        // 'neutral' is just a label in a box
        // 'prev' and 'next' show left and right arrows respectively
        // 'submit' is styled differently to stand out (CTA)
        type:      React.PropTypes.oneOf(['neutral', 'prev', 'next', 'submit', 'prominent']),

        // Generate react-router link to URL (must be in current <Route> table)
        link:      React.PropTypes.string,

        // If /link/ is set, setting /external/ will generate an <a> not a <Link>  (opposite of LinkTile.singlePageLink)
        // (so the route does not need to be configured)
        external:  React.PropTypes.bool,

        // Apply target='_blank' if set (/link/ must also be set)
        targetBlank: React.PropTypes.bool,

        // 'light' for grey 2-on-1 and 'dark' for grey 1-on-2
        theme:     React.PropTypes.oneOf(['light', 'dark']),
    },
    getDefaultProps: function() {
        return {
            inactive: false,
            onClick:  null,
            type:     'next',
            theme:    'light',
        };
    },
    getInitialState: function() {
        return {
            hover: false,
        };
    },
    _onMouseOver: function() {
        if (this.state.viewportLayout != 'desktop')
            return;

        this.setState({
            hover: true,
        });
    },
    _onMouseLeave: function() {
        if (this.state.viewportLayout != 'desktop')
            return;

        this.setState({
            hover: false,
        });
    },
    _onButtonClickCheck: function() {
        if (!this.props.inactive && this.props.onClick)
        {
            this.props.onClick();
        }
    },
    _onLinkClickCheck: function(event) {
        if (this.props.inactive && this.props.onClick)
        {
            this.props.onClick(event);
        }
    },
    render: function() {
        var classes = Classnames({
            'sp-button':                true,
            'sp-button-hover':          this.state.hover,
            'sp-button-inactive':       this.props.inactive,
            'sp-button-prominent':      this.props.type == 'prominent',
            'sp-button-submit':         this.props.type == 'submit',
            'sp-button-dark':           this.props.theme == 'dark',
        });
        if (this.props.className) {
            classes += ` ${this.props.className}`;
        }

        var dir,
            col;
        
        if (this.props.type == 'prev')
            dir = 'left';
        else if (this.props.type == 'next' || this.props.type == 'prominent')
            dir = 'right';

        if (this.props.theme == 'light') {
            if (this.props.inactive) {
                col = 5;
            } else {
                if (this.state.hover) {
                    col = 2;
                } else {
                    col = 1;
                }
            }
        } else {
            if (this.props.inactive)
                col = 5;
            else
                col = this.state.hover ? 1 : 2;
        }

        if (this.props.type == 'prominent') {
            col = this.state.hover ? 1 : 2;
        }

        var button = (
            <button className={classes} onClick={this._onButtonClickCheck} onMouseOver={this._onMouseOver} onMouseLeave={this._onMouseLeave}>
                {dir == 'left' ?
                    <img className='type-arrow type-arrow-left' src={images[dir+col]} alt='left arrow' width="5" height="12" />
                : null}

                {this.props.label}

                {dir == 'right' ?
                    <img className='type-arrow type-arrow-right' src={images[dir+col]} alt='right arrow' width="5" height="12" />
                : null}
            </button>
        );

        if (this.props.link) {
            var el,
                props = {};
            if (this.props.external) {
                el = 'a';
                props.href = this.props.link;
                props.onClick = this._onLinkClickCheck;
            } else {
                el = ReactRouter.Link;
                props.to = this.props.link;
            }
            if (this.props.targetBlank) {
                props.target = '_blank';
            }
            return React.createElement(el, props, button);
        } else {
           return button;
        }
    },
});

module.exports = Button;



// WEBPACK FOOTER //
// ./src/forms/button.jsx